module.exports = __webpack_public_path__ + "static/media/1_004.7d257cf5.jpeg";